import type { Format } from "@/types/plugins";

export default defineNuxtPlugin((nuxtApp) => {
  const headers = useRequestHeaders();
  const { $i18n } = useNuxtApp();

  const userAgent: any = (function () {
    if (typeof headers !== "undefined") {
      return headers["user-agent"];
    } else if (typeof navigator !== "undefined") {
      return navigator.userAgent;
    } else {
      return false;
    }
  })();

  const format: Format = {
    parse (value: number | string) {
      const date = value.toString()

      if (date.length == 8) {
        const year = Number(date.substring(0, 4))
        const month = Number(date.substring(4, 6))
        const day = Number(date.substring(6, 8))

        return new Date(year, month - 1, day, 0, 0, 0, 0)
      }

      return new Date()
    },
    day (d, timeZone = 'local') {
      try {
      const locale = $i18n.locale.value;
      const options: Intl.DateTimeFormatOptions = {
        weekday: 'long'
      }

      if (timeZone !== "local") {
        options.timeZone = timeZone;
      }

      return new Intl.DateTimeFormat(locale, options).format(d)
      } catch (e) {
        // console.log(e)
        return 'Invalid value'
      }
    },
    date(d, timeZone = "UTC") {
      try {
      const locale = $i18n.locale.value;
      const options: Intl.DateTimeFormatOptions = {
        day: $i18n.t("datetime.format.date.day") as Intl.DateTimeFormatOptions["day"],
        month: $i18n.t("datetime.format.date.month") as Intl.DateTimeFormatOptions["month"],
        weekday: $i18n.t("datetime.format.date.weekday") as Intl.DateTimeFormatOptions["weekday"],
        year: $i18n.t("datetime.format.date.year") as Intl.DateTimeFormatOptions["year"],
      };

      if (timeZone !== "local") {
        options.timeZone = timeZone;
      }

      return new Intl.DateTimeFormat(locale, options).format(d * 1000);
      } catch (e) {
        // console.log(e)
        return 'Invalid value'
      }
    },
    time(d, timeZone = "UTC") {
      try {
      const locale = $i18n.locale.value;
      const options: Intl.DateTimeFormatOptions = {
        hour: $i18n.t("datetime.format.time.hour") as Intl.DateTimeFormatOptions["hour"],
        minute: $i18n.t("datetime.format.time.minute") as Intl.DateTimeFormatOptions["minute"],
      };

      if (timeZone !== "local") {
        options.timeZone = timeZone;
      }

      return new Intl.DateTimeFormat(locale, options).format(d * 1000);
      } catch (e) {
        // console.log(e)
        return 'Invalid value'
      }
    },
    minuteTime(t) {
      try {
      const locale = $i18n.locale.value;
      const options: Intl.DateTimeFormatOptions = {
        hour: $i18n.t("datetime.format.time.hour") as Intl.DateTimeFormatOptions["hour"],
        minute: $i18n.t("datetime.format.time.minute") as Intl.DateTimeFormatOptions["minute"],
      };

      options.timeZone = "UTC";

      return new Intl.DateTimeFormat(locale, options).format(t * 60 * 1000);
      } catch (e) {
        // console.log(e)
        return 'Invalid value'
      }
    },
    ymd(d) {
      // return string in the format YYYYMMDD
      
      const year = d.getFullYear();
      const month = d.getMonth() + 1;
      const day = d.getDate();

      return `${year}${month.toString().padStart(2, "0")}${day.toString().padStart(2, "0")}`;
    },
    link(url) {
      return !url.match(/^[a-zA-Z]+:\/\//) ? "http://" + url : url;
    },
    maps(address) {
      const isIOS = userAgent
        ? /iPad|iPhone|iPod/.test(userAgent.platform)
        : false;

      if (isIOS) {
        return "https://maps.apple.com/?address=" + encodeURIComponent(address);
      }

      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        address
      )}`;
    },
  };

  nuxtApp.provide("format", format);
});
